<template>
  <div>
    <div ref="modal" :class="modalClassess" class="workadu-modal modal fade" role="dialog" aria-hidden="true">
        <div class="modal-mask" @click="$emit('close')">
            <div @click.stop class="modal-dialog" :class="modalDialogClassess">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="close">
                            <span>
                            &times;
                            </span>
                        </button>
                        <h4 class="modal-title" style="word-wrap: break-word">
                            <slot name="header">
                              Modal header
                            </slot>
                        </h4>
                    </div>
                    <div v-show="loading" style="text-align:center;padding:12px 4px">
                        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i><span class="sr-only">loading...</span>
                    </div>
                    <div v-show="!loading" class="modal-body">
                        <slot></slot>
                    </div>
                    <div v-if="showFooter" class="modal-footer">
                      <slot name="footer">
                        <button type="button" class="btn btn-default" @click="close" data-dismiss="modal">
                          {{__('companyadmin.forget_it')}}
                        </button>
                        <button :disabled="loading" type="submit" class="btn btn-yellow" @click.prevent="submit">
                            <span class="">{{__('companyadmin.agree_proceed')}}</span>
                        </button>
                      </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>

  </div>

</template>
<script>
export default {
    data() {
        return {
        }
    },
    props:{
        show: {type: Boolean, default: false},
        loading: {type: Boolean, default: false},
        size: {type:String, default: 'md'},
        xsFullscreen: {type:Boolean, default: false},
        xsFixedFooter: {type:Boolean, default: false},
        customClass: {type: String, default: ''},
        showFooter: { type: Boolean, default: true },
    },
    computed:{
        modalClassess(){
            return [
                this.xsFullscreen ? 'xs-fullscreen' : '',
                this.xsFixedFooter ? 'xs-fixedfooter' : '',
                this.customClass ? this.customClass : ''
            ];
        },
        modalDialogClassess(){
            return `modal-${this.size}`;
        }
    },
     mounted() {
            if (this.show == true) {
              $(this.$refs.modal).modal('show');
            }
     },
    watch:{
      show(newValue,oldValue){
        if(newValue == true && oldValue == false){
          $(this.$refs.modal).modal('show');
        }

        if(newValue == false && oldValue == true){
          $(this.$refs.modal).modal('hide');
        }
      }
    },
    methods: {
        submit(){
            this.$emit('submit');
        },
        open(){
          this.$emit('open');
        },
        close(){
          this.$emit('close');
        }
    }
}
</script>
<style lang="scss" scoped>

.btn-yellow{
  color:white;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: rgba(0, 0, 0, .5);
  display: table;
  // transition: opacity .3s ease;
}

.modal-wrapper {
   height: 100%;
   width: 100%;
  // display: table-cell;
  // vertical-align: middle;
}

.modal-body{
    max-height: 500px;
    overflow-y:auto;
}
.workadu-modal {
    position: fixed;
    top: 50px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index:1059;
}

@media (min-width: 768px) {
  .modal-xl {
    width: 90%;
   max-width:1200px;
  }


}

@media (max-width: 768px) {
  .xs-fullscreen{
    top:0px;
  }

  .xs-fullscreen .modal-dialog{
    margin:0px;
  }

  .xs-fixed-footer .model-footer{
    position: absolute;
    height: 100px;
    bottom:0;
    width: 100px;
  }
}
</style>